import axios from 'axios'

export default {
  state: {
    products: [],
    filterData: [],
    buyTogether: null,
    accessories: [],
    productsInfo: null,
    isLoading: false,
    emptyProducts: false
  },
  mutations: {
    SET_PRODUCTS_INFO (state, info) {
      if (Array.isArray(info) && !state.products.length) {
        state.emptyProducts = true
      } else {
        state.productsInfo = info
        state.products = [ ...state.products, ...info.products ]
        state.filterData = info.filter_data ?? []
      }
    },
    CLEAR_PRODUCTS_INFO (state) {
      state.productsInfo = null
      state.products = []
    },
    CLEAR_FULL_PRODUCTS_INFO (state) {
      state.productsInfo = null
      state.products = []
      state.filterData = []
    },
    SET_LOADING (state, bool) {
      state.isLoading = bool
    },
    SET_BUY_TOGETHER: (state, data) => {
      state.buyTogether = data
    },
    SET_ACCESSORIES: (state, data) => {
      state.accessories = data
    }
  },
  actions: {
    FETCH_PRODUCTS_INFO ({ commit, rootGetters, state }, { endpoint, type, productUid, categoryId }) {
      commit('SET_LOADING', true)

      const params = state.productsInfo ? { offset: state.productsInfo.offset } : {}

      if (type) params.type = type
      if (productUid) params['product_uid'] = productUid
      if (categoryId) params['category_id'] = categoryId

      return new Promise((resolve, reject) => {
        axios
          .get(rootGetters.urlLanguagePrefix + endpoint, { params })
          .then(response => {
            commit('SET_LOADING', false)
            commit('SET_PRODUCTS_INFO', response.data)
            resolve(response.data)
          })
          .catch((error) => {
            commit('SET_LOADING', false)
            commit('SET_PRODUCTS_INFO', [])
            commit('SET_ERROR_FROM_SERVER', rootGetters.translations('error_occurred'))
            reject(error)
          })
      })
    },
    GET_BUY_TOGETHER: ({ commit, rootGetters }, { productId, productIdList }) => {
      const params = {}

      if (productId) params.product_id = productId
      if (productIdList) params.product_id_list = productIdList

      axios
        .post(rootGetters.urlLanguagePrefix + '/shop/catalog/get-buy-together/', params)
        .then(res => {
          if (res.data?.success) {
            commit('SET_BUY_TOGETHER', res.data)
          }
        })
    },
    GET_ACCESSORIES: ({ commit, rootGetters }, { productId, productIdList, categoryId }) => {
      const params = {}

      if (productId) params.product_id = productId
      if (productIdList) params.product_id_list = productIdList
      if (categoryId) params.category_id = categoryId

      axios
        .post(rootGetters.urlLanguagePrefix + '/shop/catalog/get-accessories/', params)
        .then(res => {
          if (res.data?.success) {
            commit('SET_ACCESSORIES', res.data.data)
          }
        })
    }
  }
}
